import listActions from 'src/modules/entitlement/list/entitlementListActions';
import EntitlementService from 'src/modules/entitlement/entitlementService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'ENTITLEMENT_DESTROY';

const entitlementDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: entitlementDestroyActions.DESTROY_STARTED,
      });

      await EntitlementService.destroyAll([id]);

      dispatch({
        type: entitlementDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.entitlement.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/entitlement');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: entitlementDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: entitlementDestroyActions.DESTROY_ALL_STARTED,
      });

      await EntitlementService.destroyAll(ids);

      dispatch({
        type: entitlementDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.entitlement.destroyAll.success'),
      );

      getHistory().push('/entitlement');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: entitlementDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default entitlementDestroyActions;
